export default "__VITE_ASSET__C72a9b9W__"